<template>
    <transition name="fade" mode="out-in" :duration="{ enter: 700, leave: 100 }">
        <div class="product-single-container">
            <div class="wtw-container">
                <span class="stay-black back-to-search" @click="goBack">Back to search</span>
            </div>
            <slide-show-zoom
                ref="zoom" 
                v-show="showZoomModal"
                :images="zoomImages"
                :product="true"
                :index="zoomIndex"
                @close-modal="showZoomModal = false"
            />
            <product-single 
                :currentProduct="currentProduct"
                :slideShowImages="slideShowImages"
                :imageClicked="openImageZoom"
                :imageChanged="() => {}"
                :outfitImageClicked="productId => {}"
                :productChanged="product => {}"
                :hideCard="false"
                :showFooterSaveButton="true"
                v-if="currentProduct && dataLoaded && !cartLoading && !shareLoading"
                @change-product="productChanged"
                key="1"
            />
            <div v-else key="2">
                <loader></loader>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ProductSingle from '../products/product-single.vue';
    import Loader from '../common/loader.vue';
    import SlideShowZoom from '../common/slideshow-zoom.vue';

    export default {
        props: {
            productId: String,
            goBack: Function
        },
        components: {
            ProductSingle,
            Loader,
            SlideShowZoom
        },
        data() {
            return {
                dataLoaded: false,
                showZoomModal: false,
                zoomIndex: 0,
                currentProduct: null
            };
        },
        computed: {
            slideShowImages() {
                if(this.currentProduct?.product_images) {
                    let colorImages = this.currentProduct.product_images
                        .filter(image => this.currentProduct.product_option_value_id_color === image.product_option_value_id)
                    if(colorImages.length === 0) colorImages = this.currentProduct.product_images;
                    return colorImages
                        .map(image => {
                            return {
                                uri: image.product_image_uri,
                                zoomUri: image.product_image_zoom_uri,
                                alt: `${image.product_title}_${image.product_image_id}`,
                                key: image.product_image_id,
                            };
                        });
                }
                
                return [];
            },
            zoomImages() {
                return this.slideShowImages.map(image => image.zoomUri);
            },
            ...mapGetters({
                shareLoading: 'share/getLoadingStatus',
                cartLoading: 'cart/getLoadingStatus',
            })
        },
        methods: {
            openImageZoom(index) {
                this.showZoomModal = true;
                this.zoomIndex = index;
                this.$refs.zoom.opened();
            },
            productChanged(newProduct) {
                this.getProduct(newProduct.product_id);
                this.$emit('change', newProduct.product_id)
            },
            getProduct(id) {
                this.dataLoaded = false;
                this.$store.dispatch('search/getProduct', {
                    id
                }).then((response) => {
                    this.currentProduct = response.product;
                    this.dataLoaded = true;
                });
            }
        },
        mounted() {
            if (this.productId) {
                this.getProduct(this.productId);
            }
        },
    };
</script>


<style lang="scss">
    $imageHeight-xs: 190px;
    $imageHeight-sm: 250px;
    $imageHeight-md: 380px;

    .search-wrapper {
        .product-single-container {
            height: calc(100vh - 120px);
            width: 100vw;
            display: flex;
            flex-flow: column;
            overflow-y: scroll;
            .product-wrapper {
                padding: 0 20px;
                .footer-buttons-container {
                    .footer-button {
                        flex: 1;
                        margin: 0 5px;
                    }
                }
            }
        }
    }
</style>